<template>
    <div class="qksm qksm5">
        <h4>五、财政拨款支出决算情况说明</h4>
        <div class="nogap">
            <p>
                财政拨款支出决算反映的是一般公共预算、政府性基金预算和国有资本经营预算财政拨款支出的总体情况，既包括使用本年从本级财政取得的拨款发生的支出，也包括使用上年度财政拨款结转和结余资金发生的支出。
                {{$store.state.divData.divname}}2020年财政拨款支出{{isMoney(T5.总计)}}万元，占本年支出合计的{{calcRatio(T5.总计,T3.总计)}}。
                {{$store.state.divData.divname}}2020年度财政拨款支出年初预算为<reason type="money" classname="qksm money " name="财政拨款年初预算" v-model:value="qksm['财政拨款年初预算']"></reason>万元，
                支出决算为{{isMoney(T5.总计)}}万元
                <template v-if="num(qksm['财政拨款年初预算'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "。" : "（年初预算数为0万元，无法计算完成比例）。"}}
                </template>
                <template v-else>
                    ，完成年初预算的{{calcRatio(T5.总计,qksm['财政拨款年初预算'])}}。
                    <template v-if="$store.state.divData.zone=='xuzhou' && num(qksm['财政拨款年初预算'])==num(T5.总计)">
                        决算数等于预算数。
                    </template>
                </template>
                <template v-if="items.length>0">
                    其中：
                </template>
            </p>
            <template v-for="(item,idx) in items">
                <p>{{items.length>1 ? "（"+intToChinese(idx+1)+"）" :""}}{{item.lei}}</p>
                <p v-if="item.kuan.length==0">
                    {{item.lei}}。年初预算为
                    <reason type="money" classname="qksm money" :name="item.code+'预算'" v-model:value="qksm[item.code+'预算']"></reason>万元，支出决算为{{isMoney(item.value)}}万元
                    <template v-if="num(qksm[item.code+'预算'])==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（年初预算数为0万元，无法计算完成比例）。"}}
                    </template>
                    <template v-else>
                        ，完成年初预算的{{calcRatio(item.value,qksm[item.code+'预算'])}}。
                        <template v-if="$store.state.divData.zone=='xuzhou' && num(qksm[item.code+'预算'])==num(item.value)">
                            决算数等于预算数。
                        </template>
                    </template>
                    <template v-if="num(item.value)!=num(qksm[item.code+'预算'])">
                        决算数{{num(item.value)>num(qksm[item.code+'预算']) ? "大于" : "小于"}}预算数的主要原因
                        <reason type="textarea" classname="qksm widest" :name="item.code+'原因'" v-model:value="qksm[item.code+'原因']"></reason>
                    </template>
                </p>
                <p v-else v-for="(itemk,idy) in item.kuan">
                    {{item.kuan.length>1 ? idy+1+". " :""}}{{itemk.kuan}}{{itemk.xiang}}。年初预算为
                    <reason type="money" classname="qksm money" :name="itemk.code+'预算'" v-model:value="qksm[itemk.code+'预算']"></reason>万元，支出决算为{{isMoney(itemk.value)}}万元
                    <template v-if="num(qksm[itemk.code+'预算'])==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（年初预算数为0万元，无法计算完成比例）。"}}
                    </template>
                    <template v-else>
                        ，完成年初预算的{{calcRatio(itemk.value,qksm[itemk.code+'预算'])}}。
                        <template v-if="$store.state.divData.zone=='xuzhou' && num(qksm[itemk.code+'预算'])==num(itemk.value)">
                            决算数等于预算数。
                        </template>
                    </template>
                    <template v-if="num(itemk.value)!=num(qksm[itemk.code+'预算'])">
                        决算数{{num(itemk.value)>num(qksm[itemk.code+'预算']) ? "大于" : "小于"}}预算数的主要原因
                        <reason type="textarea" classname="qksm widest" :name="itemk.code+'原因'" v-model:value="qksm[itemk.code+'原因']"></reason>
                    </template>
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        props: {
            T3: {
                type: Object,
                default: "",
            },
            T5: {
                type: Object,
                default: "",
            },
        },
        created() {
            var arr = [];
            this.T5.items.map(a => {
                var arrKuan = [];
                a.children.map(b => {
                    if (b.children.length == 0) {
                        this.qksm[b.code + '预算'] = this.pickOneOf(this.qksm[b.code + '预算'], (this.$store.state.divData.zone == "zhangjiagang" || this.$store.state.divData.zone == "taicang" ? b.value_ys : this.num(b.value_ys)))
                        arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: "", code: b.code, value: this.isMoney(b.value), })
                    } else {
                        b.children.map(c => {
                            this.qksm[c.code + '预算'] = this.pickOneOf(this.qksm[c.code + '预算'], (this.$store.state.divData.zone == "zhangjiagang" || this.$store.state.divData.zone == "taicang"  ? c.value_ys : this.num(c.value_ys)))
                            arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: c.name + "（项）", code: c.code, value: this.isMoney(c.value), })
                        })
                    }
                })
                arr.push({ lei: a.name + "（类）", code: a.code, value: this.isMoney(a.value), kuan: arrKuan })
            })
            this.items = arr
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            qksm['财政拨款年初预算'] = this.pickOneOf(qksm['财政拨款年初预算'], (this.$store.state.divData.zone == "zhangjiagang" || this.$store.state.divData.zone == "taicang"  ? this.T5.总计_ys : this.num(this.T5.总计_ys)))
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },

    };
</script>
